{
  "coach": {
    "institutionCard": {
      "addFavouriteAriaLabel": "Save {institutionTitle} to your favourites",
      "removeFavouriteAriaLabel": "Remove {institutionTitle} from your favourites"
    },
    "chat": {
      "error": "That didn’t go through. Give it another go."
    },
    "lessons": {
      "pageSubtitle": "Work your teachers set you, and more from your school.",
      "setByTeacher": "Set for you by your teacher",
      "empty": {
        "title": "Nothing set yet",
        "description": "When your school sets you a lesson, you’ll find it here."
      },
      "unavailable": "That lesson isn’t available any more. Your list has been updated."
    },
    "school": {
      "setBy": "Set by {school}"
    }
  }
}
